import Icon, { IconName } from '@pathccm/rula-ui/icon';
import React from 'react';

type TextWithIconProps = {
  icon: IconName;
  iconSize?: 'small' | 'large' | number; // this matches the Icon component's size prop, which is not exported
  children?: React.ReactNode;
};

export const WithIcon: React.FC<TextWithIconProps> = ({
  icon,
  iconSize = 'large',
  children,
}) => {
  return (
    <div className="flex items-center space-x-2">
      <Icon icon={icon} size={iconSize} />
      {children}
    </div>
  );
};
